import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { Button, Form, Table } from "react-bootstrap";
import { FaLock, FaLockOpen, FaPlus, FaRegTrashAlt, FaTrashAlt } from "react-icons/fa";
import { NoDataFoundTable } from "../../../Hooks/NoDataFoundTable";
import UseToggle from "../../../Hooks/UseToggle";
import Pagination from "../../../Hooks/Pagination";
import BlogPostActivity from "./BlogPostActivity";
import AddBlogPost from "./AddBlogPost";
import Swal from "sweetalert2";
import DeletedBlogPost from "./DeletedBlogPost";
import { blogPostServices } from "../../../APIServices/GlobalManagement/BlogManagement/blogPostServices";
import UpdateBlogPost from "./UpdateBlogPost";
import BlogPostPreview from "./BlogPostPreview";
import Moment from "react-moment";

const BlogPost = () => {
  const toggles = UseToggle();
  
  const [searchData, setSearchData] = useState("");
  const [blogPostList, setBlogPostList] = useState([]);
  const [blogPostCount, setBlogPostCount] = useState(0);
  const [singleBlogPost, setSingleBlogPost] = useState("");
  
  const [deletedBlogPost, setDeletedBlogPost] = useState([]);
  const [deletedBlogPostCount, setDeletedBlogPostCount] = useState(0);
  
  const [blogPostdata, setBlogPostdata] = useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const [openModule, setOpenModule] = useState("preview");
  
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(blogPostCount / itemsPerPage);
  
  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);
  
  const tabs = [
    { key: "preview", label: "Preview" },
    ...(!singleBlogPost?.lockStatus
      ? [{ key: "blogPostEditor", label: "Blog Post Editor" }]
      : []),
    { key: "activity", label: "Activity" },
  ];
  
  const getBlogPostList = async () => {
    let data = await blogPostServices.getBlogPostList(
      "all",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setBlogPostList(data?.data || []);
    setBlogPostCount(data?.count || 0);
  };

  const getDeletedBlogPostList = async () => {
    let data = await blogPostServices.getBlogPostList(
      "deleted",
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedBlogPost(data?.data || []);
    setDeletedBlogPostCount(data?.count || 0);
  };

  const softDeleteRestoreBlogPost = async (formId, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} blog post?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { formId, type };
      const data = await blogPostServices.softDeleteRestoreBlogPost(userData);
      if (data?.statusCode === 200) {
        getBlogPostList();
        getDeletedBlogPostList();
      }
    });
  };

  const updatedLockBlogPost = async (postId, lockStatus) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${lockStatus ? "lock" : "unlock"} Blog Post?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { postId, lockType: true, lockStatus };
      const data = await blogPostServices.updatedBlogPost(userData);
      if (data?.statusCode === 200) getBlogPostList();
    });
  };

  useEffect(() => {
    getBlogPostList();
  }, [searchData, pageNumber, itemsPerPage]);

  const getSingleBlogPost = async () => {
    let data = await blogPostServices.getSingleBlogPost(blogPostdata?.postId);
    setSingleBlogPost(data?.data || "");
  };

  useEffect(() => {
    if (blogPostdata) {
      getSingleBlogPost()
    }
  }, [blogPostdata]);
  
  return (
    <>
    <div style={{ background: "#eee" }}>
      <div className="p-2 d-flex gap-2">
        <div className={`meta-table overflow-auto`} style={{ height: "calc(100vh - 71px)", flex: openPreview ? ".5 0 " : ""}}>
          <div className="hstack gap-2 pb-2 bg-white">
            <Button
              size="sm"
              variant="outline-primary"
              className="hstack gap-2 text-nowrap rounded-1 border"
              style={{ fontSize: 13 }}
              onClick={toggles.setToggle}
            >
              <FaPlus /> {!openPreview && "Add New"}
            </Button>
            <div className="search-box position-relative w-100">
              <FiSearch />
              <Form.Control
                type="search"
                className="w-100 rounded-1"
                style={{ fontSize: 13 }}
                placeholder="Search..."
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
              />
            </div>
            {deletedBlogPostCount > 0 && (
              <Button
                variant="outline-danger"
                className="hstack gap-2 text-nowrap rounded-1 border"
                style={{ fontSize: 13 }}
                onClick={toggles.setToggle2}
              >
                <FaRegTrashAlt /> {!openPreview && "Deleted History"}
              </Button>
            )}
          </div>
          <div className="overflow-auto" style={{ height: "calc(100vh - 122px)"}}>
            {blogPostCount === 0 ? (
              <NoDataFoundTable MSG="No Blog Post." />
            ) : (
              <>
                <Table hover responsive className="">
                  <thead className="position-sticky" style={{ top: -1 }}>
                    <tr>
                      <th style={{ width: 45 }} className="text-center">
                        Sr.
                      </th>
                      <th style={{ width: !openPreview && "30%" }}>Title</th>
                      {!openPreview && (
                        <>
                          <th>Category</th>
                          <th>Subcategory</th>
                          <th>Post By</th>
                          <th>Post Date | Time</th>
                          <th>Update Date | Time</th>
                          <th>Status</th>
                          <th className="text-center">Lock</th>
                          <th className="text-center" style={{ width: 80 }}>
                            Actions
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {blogPostList?.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          blogPostdata?.postId === item.postId ? "selectedRow CP" : "CP"
                        }
                        onClick={() => {
                          setOpenPreview(true);
                          setBlogPostdata(item);
                        }}
                      >
                        <td className="text-center">{startIndex + index + 1}</td>
                        <td className="text-truncate text-wrap" style={{ maxWidth: 100 }}>
                          <strong>{item.title}</strong>
                          <div className="sub-text">
                            {item.shortDescription}
                          </div>
                        </td>
                        {!openPreview && (
                          <>
                            <td>{item.categoryName}</td>
                            <td>{item.subCategoryName}</td>
                            <td>{item.createdByName}</td>
                            <td><Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                              {item?.createdAt}
                            </Moment></td>
                            <td><Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                              {item?.updatedAt}
                            </Moment></td>
                            <td className={`text-capitalize fw-bold ${item.status === "active" ? "text-success" : item.status === "inactive" ? "text-danger" : "text-muted"}`}>{item.status}</td>
                            <td
                              className="text-center CP"
                              title="Lock Status"
                              onClick={(e) => {
                                e.stopPropagation();
                                updatedLockBlogPost(item.postId, !item.lockStatus);
                              }}
                            >
                              {item.lockStatus ? (
                                <FaLock className="text-success" />
                              ) : (
                                <FaLockOpen className="text-danger" />
                              )}
                            </td>
                            <td className="text-center actions">
                              <FaTrashAlt
                                title="Delete"
                                onClick={(e) => {e.stopPropagation();
                                if (!item.lockStatus) {
                                    softDeleteRestoreBlogPost(
                                      item.postId,
                                      "delete"
                                    );
                                  }} }
                                className={`icon danger CP ${item.lockStatus ? "disabled" : ""}`}
                              />
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={blogPostCount?.totalItems}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {openPreview && (
          <div className="meta-preview" style={{ flex: "1.5 0" }}>
            <div className="preview-header hstack justify-content-between">
              <div className="hstack gap-2">
                {tabs.map((tab) => (
                  <Button
                    key={tab.key}
                    size="sm"
                    style={{ fontSize: 13 }}
                    variant={
                      openModule === tab.key ? "primary" : "outline-primary"
                    }
                    onClick={() => setOpenModule(tab.key)}
                  >
                    {tab.label}
                  </Button>
                ))}
              </div>
              <Button
                size="sm"
                style={{ fontSize: 13 }}
                variant="outline-danger"
                onClick={() => setOpenPreview(false)}
              >
                Close
              </Button>
            </div>
            {openModule === "preview" && (
              <div
                className="overflow-auto"
                style={{ height: "calc(100vh - 123px)" }}
              >
              <div
                className="w-75 m-auto"
              >
                <BlogPostPreview singleBlogPost={singleBlogPost}/>
              </div>
              </div>
            )}
            {openModule === "blogPostEditor" && (
              <UpdateBlogPost
                singleBlogPost={singleBlogPost}
                getBlogPostList={getBlogPostList}
                getSingleBlogPost={getSingleBlogPost}
              />
            )}
            {openModule === "activity" && <BlogPostActivity />}
          </div>
        )}
      </div>
    </div>
    <AddBlogPost
      Show={!toggles?.toggle}
      Hide={toggles?.setToggle}
      Title={`Add New Blog Post`}
      getBlogPostList={getBlogPostList}
      />

      <DeletedBlogPost
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={`Restore Mail Blog Posts`}
        deletedBlogPost={deletedBlogPost}
        softDeleteRestoreBlogPost={softDeleteRestoreBlogPost}
        deletedBlogPostCount={deletedBlogPostCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        getDeletedBlogPostList={getDeletedBlogPostList}
      />
    </>
  );
};

export default BlogPost;
